module.exports = __webpack_public_path__ + "media/images/lb/984-fd9d97c0e0d7e6fc8642aecf009bf4e2.svg";